import { Suspense, lazy } from 'react'

import { Route, Routes } from 'react-router-dom'

import { RouteAccess } from 'app/routes/route-access'
import { RoutingPaths } from 'app/routes/routes'

import { IS_DIGITAL_TOUR_SUPPORT_ENABLED } from 'shared/constants/tours'

import {
  AllDirectionsPage,
  ClientDataPage,
  DeparturePage,
  DirectionPage,
  DocumentDetailsPage,
  DocumentPaymentHistoryPage,
  DocumentTouristsPage,
  FilterRoomPage,
  FlightDetailsPage,
  FlightSelectionPage,
  GalleryPage,
  HotTourDetailPage,
  HotToursPage,
  HotelMapPage,
  HotelRoomDetailsPage,
  HotelRoomsPage,
  MyOrdersDetailsPage,
  PreviewPage,
  ResortTypePage,
  RoomGalleryPage,
  RoomPreviewPage,
  ScanDocumentPage,
  SearchResultPage,
  SelectNightsPage,
  SelectPeoplePage,
  SortPage,
  SpecialToursPage,
  SuccessPage,
  TourDetailPage,
  TourSearchFormPage,
  ToursCalendarPage,
  ToursMainPage,
} from '../'

const ContractPage = lazy(() => import('../contract-page'))
const DocumentPartialPaymentPage = lazy(
  () => import('../document/pages/partial-payment'),
)

export const ToursPages = () => {
  return (
    <Routes>
      <Route
        path={RoutingPaths.tours.contract.base()}
        element={
          <RouteAccess enabled={IS_DIGITAL_TOUR_SUPPORT_ENABLED}>
            <Suspense fallback={null}>
              <ContractPage />
            </Suspense>
          </RouteAccess>
        }
      />
      <Route
        path={RoutingPaths.tours.start()}
        element={<ToursMainPage />}
      />

      <Route
        path={RoutingPaths.tours.searchDeparture.base()}
        element={<DeparturePage />}
      />
      <Route
        path={RoutingPaths.tours.searchDirection.base()}
        element={<DirectionPage />}
      />
      <Route
        path={RoutingPaths.tours.allDirections.base()}
        element={<AllDirectionsPage />}
      />
      <Route
        path={RoutingPaths.tours.resortTypePage.base()}
        element={<ResortTypePage />}
      />

      <Route
        path={RoutingPaths.tours.calendar.base()}
        element={<ToursCalendarPage />}
      />
      <Route
        path={RoutingPaths.tours.selectPeople.base()}
        element={<SelectPeoplePage />}
      />

      <Route
        path={RoutingPaths.tours.selectNights.base()}
        element={<SelectNightsPage />}
      />

      <Route
        path={RoutingPaths.tours.tourDetail.base()}
        element={<TourDetailPage />}
      />

      <Route
        path={RoutingPaths.tours.tourDetail.baseShare()}
        element={<TourDetailPage />}
      />

      <Route
        path={RoutingPaths.tours.searchResults.base()}
        element={<SearchResultPage />}
      />

      <Route
        path={RoutingPaths.tours.searchForm.base()}
        element={<TourSearchFormPage />}
      />

      <Route
        path={RoutingPaths.tours.specialTours.base()}
        element={<SpecialToursPage />}
      />

      <Route
        path={RoutingPaths.tours.gallery.base()}
        element={<GalleryPage />}
      />

      <Route
        path={RoutingPaths.tours.roomGallery.base()}
        element={<RoomGalleryPage />}
      />

      <Route
        path={RoutingPaths.tours.roomPreview.base()}
        element={<RoomPreviewPage />}
      />

      <Route
        path={RoutingPaths.tours.preview.base()}
        element={<PreviewPage />}
      />

      <Route
        path={RoutingPaths.tours.sort.base()}
        element={<SortPage />}
      />

      <Route
        path={RoutingPaths.tours.hotelRooms.base()}
        element={<HotelRoomsPage />}
      />

      <Route
        path={RoutingPaths.tours.hotelRoomDetails.base()}
        element={<HotelRoomDetailsPage />}
      />

      <Route
        path={RoutingPaths.tours.clientData.base()}
        element={<ClientDataPage />}
      />

      <Route
        path={RoutingPaths.tours.scanPassword.base()}
        element={<ScanDocumentPage />}
      />

      <Route
        path={RoutingPaths.tours.hotelRooms.base()}
        element={<HotelRoomsPage />}
      />

      <Route
        path={RoutingPaths.tours.hotelRoomDetails.base()}
        element={<HotelRoomDetailsPage />}
      />

      <Route
        path={RoutingPaths.tours.flightSelection.base()}
        element={<FlightSelectionPage />}
      />

      <Route
        path={RoutingPaths.tours.flightDetails.base()}
        element={<FlightDetailsPage />}
      />

      <Route
        path={RoutingPaths.tours.myOrderDetails.base()}
        element={<MyOrdersDetailsPage />}
      />

      <Route
        path={RoutingPaths.tours.documentDetails.base()}
        element={
          <RouteAccess enabled={IS_DIGITAL_TOUR_SUPPORT_ENABLED}>
            <DocumentDetailsPage />
          </RouteAccess>
        }
      />

      <Route
        path={RoutingPaths.tours.documentDetails.partialPayment.base()}
        element={
          <RouteAccess enabled={IS_DIGITAL_TOUR_SUPPORT_ENABLED}>
            <Suspense fallback={null}>
              <DocumentPartialPaymentPage />
            </Suspense>
          </RouteAccess>
        }
      />

      <Route
        path={RoutingPaths.tours.documentDetails.paymentHistory.base()}
        element={
          <RouteAccess enabled={IS_DIGITAL_TOUR_SUPPORT_ENABLED}>
            <DocumentPaymentHistoryPage />
          </RouteAccess>
        }
      />

      <Route
        path={RoutingPaths.tours.documentDetails.tourists.base()}
        element={
          <RouteAccess enabled={IS_DIGITAL_TOUR_SUPPORT_ENABLED}>
            <DocumentTouristsPage />
          </RouteAccess>
        }
      />

      <Route
        path={RoutingPaths.tours.success.base()}
        element={<SuccessPage />}
      />

      <Route
        path={RoutingPaths.tours.hotelMap.base()}
        element={<HotelMapPage />}
      />

      <Route
        path={RoutingPaths.tours.roomFilter.base()}
        element={<FilterRoomPage />}
      />

      <Route
        path={RoutingPaths.tours.hotTours.base()}
        element={<HotToursPage />}
      />

      <Route
        path={RoutingPaths.tours.hotTourDetailPage.base()}
        element={<HotTourDetailPage />}
      />

      <Route
        path={RoutingPaths.tours.roomFilter.base()}
        element={<FilterRoomPage />}
      />
    </Routes>
  )
}
